<script setup>
defineProps({
    type: {
        type: String,
        default: 'button',
    },
    textSize: {
        type: String,
        default: 'text-base',
    },
    color: {
        type: String,
        default: null,
    },
    textColor: {
        type: String,
        default: 'white',
    },
    height: {
        type: String,
        default: null,
    }
});
</script>

<template>
    <button
        :type="type"
        :class="[
            'primary-button',
            textSize,
            color ? '' : 'default-color'
        ]"
        :style="{
            backgroundColor: color || 'var(--app-color-primary)',
            color: textColor,
            height: height || 'auto'
        }">
        <slot/>
    </button>
</template>

<style lang="scss" scoped>
button.default-color {
    background-color: var(--app-color-primary);
}

.primary-button {
    @apply px-4 py-2 rounded font-semibold text-nowrap hover:opacity-80 active:opacity-100;
    line-height: 25.35px;
}
</style>
